<template app>
<div class="blog-post">
     <v-text-field
          class="style-input sm3"
          :label="filters.label"
              v-model="filters.default"
      outline
        height="30"
        
          v-on:change="triggerEvent"
          type="text"
    />
</div>
</template>

<script>
import DropDownModel from '@/api/service/DropDownService'

  export default {
   props: ["filters","selected"],

 data () {
      return {
          selectedId:0,
        items:[]
      }
    },
    created: function() {
      
  },
  methods: {
      triggerEvent($v,$event) {
          console.log($v)
          var $json ={}
          $json[this.filters.id]=$v;
          this.$emit('change',$json)

      }
      }
  }
</script>